import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '@shared-models';
import { sunbedReducer } from './sunbed.reducer';

export const reducers: ActionReducerMap<AppState> = {
  sunbeds: sunbedReducer,
};
